import { faGitlab, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faCat, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type React from 'react';
import { useCallback } from 'react';

import styles from './App.module.css';
import { useWindowsStore } from './+state/store';
import { Clock, Icon } from './components/desktop';
import { Background } from './components/desktop/Background/Background';
import { WindowList } from './components/desktop/WindowList';
import { MICROFRONTENDS } from './microfrontends';
import selfy from './me.jpg';

export const App: React.FC = () => {
    const windows = useWindowsStore((state) => state.windows);
    const startMenuOpen = useWindowsStore((state) => state.startMenuOpen);
    const focusWindow = useWindowsStore((state) => state.focusWindow);
    const openWindow = useWindowsStore((state) => state.openWindow);
    const setStartMenu = useWindowsStore((state) => state.setStartMenu);
    const toggleStartMenu = useWindowsStore((state) => state.toggleStartMenu);

    const closeStartMenu = useCallback(
        (event: React.MouseEvent<HTMLElement>): void => {
            event.stopPropagation();
            setStartMenu(false);
        },
        [setStartMenu],
    );

    return (
        <div onClick={closeStartMenu}>
            <Background />
            <div className={styles.app}>
                <div className={styles.desktop}>
                    {MICROFRONTENDS.map(({ icon, label }) => (
                        <Icon
                            key={label}
                            label={label}
                            icon={icon}
                            onClick={() => openWindow(label)}
                        />
                    ))}
                    <WindowList />
                </div>
                <div
                    className={
                        styles.start +
                        ' ' +
                        (startMenuOpen ? styles.startOpen : '')
                    }
                >
                    <div
                        className={styles.start__menu}
                        onClick={(evt) => evt.stopPropagation()}
                    >
                        <img src={selfy} alt="Me, lurking in the start menu" />
                        {MICROFRONTENDS.map(({ icon, label }) => (
                            <div
                                key={label}
                                className={styles.start__menuItem}
                                onClick={() => openWindow(label)}
                            >
                                <FontAwesomeIcon
                                    fixedWidth={true}
                                    icon={icon}
                                />
                                {label}
                            </div>
                        ))}

                        <a
                            href="https://www.linkedin.com/in/florian-adomeit-7310805a"
                            className={styles.start__menuItem}
                            target="_noopener noreferrer"
                        >
                            <FontAwesomeIcon
                                fixedWidth={true}
                                icon={faLinkedin}
                            />
                            LinkedIn
                        </a>
                        <a
                            href="https://gitlab.com/noVerity/me"
                            className={styles.start__menuItem}
                            target="_noopener noreferrer"
                        >
                            <FontAwesomeIcon
                                fixedWidth={true}
                                icon={faGitlab}
                            />
                            View Source
                        </a>
                        <a
                            href="https://stackoverflow.com/"
                            className={styles.start__menuItem}
                        >
                            <FontAwesomeIcon
                                fixedWidth={true}
                                icon={faSignOutAlt}
                            />
                            Logout
                        </a>
                    </div>
                    <div
                        className={styles.start__button}
                        onClick={(evt) => {
                            evt.stopPropagation();
                            toggleStartMenu();
                        }}
                    >
                        <FontAwesomeIcon icon={faCat} />
                        Florian Adomeit
                    </div>
                    <div className={styles.start__windows}>
                        {windows.map((window) => (
                            <span
                                key={window}
                                className={styles.start__item}
                                onClick={() => focusWindow(window)}
                            >
                                {window}
                            </span>
                        ))}
                    </div>
                    <div className={styles.start__profile}>
                        <div className={styles.start__date}>
                            <Clock />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default App;
